import { Row, Col } from 'react-bootstrap';
import CurrencyField from '../../fields/CurrencyField';
import PercentageField from '../../fields/PercentageField';
import AdditionalInformationField from '../../fields/AdditionalInformationField';
import IncomeInformationInputs from '../../common/IncomeInformationInputs';
import CalculatedIncomeResults from '../../common/CalculatedIncomeResults';
import { FUND_TYPES, STATES } from '../../../../constants/constants';
import CaresBenefitDiff from '../cares/CaresBenefitDiff';

const LiheapSection = ({
  state,
  currentEnergyDiscount,
  householdSize,
  onHouseholdSizeChange,
  income,
  onIncomeChange,
  energyDiscount,
  incomeMeasurementType,
  incomeMeasurementPercentage,
  arrearage,
  pledgeAmount,
  onPledgeAmountChange,
  additionalInformation,
  onAdditionalInformationChange,
  isSubmitting,
}) => {
  const isWA = state === STATES.WA;

  return (
    <>
      {isWA && (
        <>
        <hr/>
        {/* Income Information */}
        <Row>
          <Col>
            <h4>Income Information</h4>

            <IncomeInformationInputs
              householdSize={householdSize}
              onHouseholdSizeChange={onHouseholdSizeChange}
              income={income}
              onIncomeChange={onIncomeChange}
              isSubmitting={isSubmitting}
            />
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <CalculatedIncomeResults
              incomeMeasurementType={incomeMeasurementType}
              incomeMeasurementPercentage={incomeMeasurementPercentage}
              arrearage={arrearage}
              isSubmitting={isSubmitting}
            />
          </Col>
        </Row>

        <CaresBenefitDiff
          fundType={FUND_TYPES.LIHEAP}
          newEnergyDiscount={energyDiscount}
          currentEnergyDiscount={currentEnergyDiscount}
        />
        </>
      )}

      <hr/>
      {/* Benefit Amounts */}
      <Row>
        <Col><h4>Benefit Amounts</h4>
          <Row>
            {/* Adding CARES Discount with LIHEAP is WA-only (for now) */}
            {isWA && (
            <Col md={6}>
              <PercentageField
                value={energyDiscount}
                fieldName="Energy Discount"
                readonly
                disabled
                isSubmitting={isSubmitting}
                />
            </Col>
            )}
            <Col md={6}>
            <CurrencyField
              min={1}
              fieldName="Pledge Amount"
              value={pledgeAmount}
              onChange={onPledgeAmountChange}
              isSubmitting={isSubmitting}
              required
            />
            </Col>
          </Row>
        </Col>
      </Row>

      <hr/>

      {/* Additional Information */}
      <Row className="mt-3">
        <Col>
          <AdditionalInformationField
            value={additionalInformation}
            onChange={onAdditionalInformationChange}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
    </>
  );
};

export default LiheapSection;